import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectAllUsers } from '../users/usersSlice';
import { useNavigate } from 'react-router-dom';

import { adders } from './postsSlice';
import { FeatureForCamelCaseCRUD } from './postsSlice';



const AddFormPost = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [userId, setUserId] = useState('');
  const [addRequestStatus, setAddRequestStatus] = useState('idle');
  
  const users = useSelector(selectAllUsers);
  
  const onTitleChange = e => setTitle(e.target.value);
  const onContentChange = e => setContent(e.target.value);
  const onAuthorChange = e => setUserId(e.target.value);
  const canSave = [title, content, userId].every(Boolean) && addRequestStatus === 'idle';


  const onSavePostClicked = () => {
    if(canSave) {
      try{
        setAddRequestStatus('pending');
        dispatch(adders[`addNew${FeatureForCamelCaseCRUD}`]({title, content, userId})).unwrap();

        setUserId('');
        setTitle('');
        setContent('');
        navigate('/posts')
      }catch(err){
        console.error('Failed to save the post', err)
      }finally{
        setAddRequestStatus('idle')
      }
      //window.location.reload();  
    }
  }

  const usersOptions = users.map((user) => (
    <option value={user.id} key={user.id}>
      {user.name}
    </option>
  ))

  return (
    <div className="container">
      <h2>Add a new Post</h2>
      <Form onSubmit={onSavePostClicked}>
        {/* <label htmlFor="postAuthor">Author</label> */}
        <Form.Control as="select" 
          size="sm"
          name="postAuthor" 
          id="postAuthor"
          placeholder="Select Author" 
          value={userId}
          onChange={onAuthorChange}
        >
          <option value=""></option>
          {usersOptions}
        </Form.Control>
        <br />
        {/* <label htmlFor="title">Title</label> */}
        <Form.Control 
          size="sm"
          type="text"
          id="postTitle"
          name="title"
          placeholder="Your post title"
          value={title}
          onChange={onTitleChange} 
        />
        <br />
        {/* <label htmlFor="content">Content</label> */}
        <Form.Control as="textarea" 
          size="sm"
          type="text"
          id="postContent"
          name="content"
          placeholder="Your post content"
          value={content}
          onChange={onContentChange} 
        />
        <br />
        <Button
          type="submit"
          className="my-1"
          /* onClick={onSavePostClicked} */
          disabled={!canSave}
          variant="outline-warning"
          size="block"
        >Save post</Button>
      
      </Form>
    </div>
  )
}

export default AddFormPost